import { useContext } from 'react'
import { AdditionalContext } from '../context/additionalContext'

const useAdditional = () => {
    const values = useContext(AdditionalContext)

    return { ...values }
}

export default useAdditional
